// extracted by mini-css-extract-plugin
export default {"otpDiv":"otp_otpDiv__Ct7xo","otpField":"otp_otpField__hj9vd"};